import { getWindow } from './global'

/**
 * Lets components set the window title and use it for notification.
 */
class TabTitle {
  private title: string
  private flashTitle: string | null
  private isFlashOn: boolean

  constructor() {
    getWindow()!.setInterval(() => this.tick(), 1000)
    this.title = getWindow()!.document.title
    this.flashTitle = null
    this.isFlashOn = false
  }

  set(newTitle: string) {
    this.title = newTitle
    this.flashTitle = null
    getWindow()!.document.title = newTitle
  }

  setMaybeFlashing(newTitle: string) {
    this.title = newTitle
    getWindow()!.document.title = newTitle
  }

  setFlashAltTitle(flashTitle: string | null) {
    this.flashTitle = flashTitle
  }

  stopFlashing() {
    this.setFlashAltTitle(null)
  }

  isFlashing() {
    return this.flashTitle != null
  }

  private tick() {
    this.isFlashOn = !this.isFlashOn
    const title = this.isFlashOn && this.flashTitle != null ? this.flashTitle : this.title
    getWindow()!.document.title = title
  }
}

export default new TabTitle()
